import SocialLogin from "./SocialLogin";

export default function AppleLoginPage() {
    return <SocialLogin type="apple" />
}